import {homeSliderTypes} from "../types/homeSliderTypes";

const initState = {
    sliders: null,
    sliderIsLoading: true,
};


const homeSliderReducer = (state = initState, action) => {
    switch (action.type) {
        case homeSliderTypes.GET_HOME_SLIDERS:
            state = {
                ...state,
                sliders: action.payload,
                sliderIsLoading: false,
            };
            break;
        case homeSliderTypes.CLEAR_HOME_INTRO:
            state = {
                ...state,
                sliders: null,
                sliderIsLoading: true,
            };
            break;
        default:
        // do nothing
    }
    return state;
};


export default homeSliderReducer;